import { SignIn as ClerkSignIn } from "@clerk/react";
import ErrorBanner from "../components/ErrorBanner.jsx";

/**
 * Sign-in screen. Uses Clerk's hosted SignIn widget which handles magic-link,
 * social login, and any other methods configured in the Clerk Dashboard.
 * After successful auth, Clerk updates session state; App.jsx's useAuth()
 * hook picks up isSignedIn=true and loads the user record automatically.
 *
 * `error` is only shown for session-invalidation cases (e.g. admin
 * deactivated the worker's account mid-session) — not for Clerk sign-in
 * failures, which Clerk surfaces internally.
 */
export default function SignIn({ error }) {
  return (
    <div className="mx-auto flex h-full max-w-md flex-col justify-center px-6 safe-top safe-bottom">
      <div className="mb-8">
        <div className="text-sm uppercase tracking-wide text-endeavor-600">
          Endeavor Health Services
        </div>
        <h1 className="mt-1 text-3xl font-bold text-slate-900">Mileage</h1>
        <p className="mt-2 text-sm text-slate-600">
          Log your daily trips and produce the month-end reimbursement form.
        </p>
      </div>
      {error && <ErrorBanner message={error} />}
      <ClerkSignIn routing="virtual" />
    </div>
  );
}
